export const RegistryTypes = Object.freeze({
  QUAY: 1,
  AZURE: 2,
  CUSTOM: 3,
  GITLAB: 4,
});
